export enum RESET_LAYOUT {
	LAYOUT_HEADER = 'Reset platform and user activities',
	RESET_LABEL = 'Reset will delete',
	LIST_ITEM_1 = 'All user activity and restore the platform to its original settings',
	LIST_ITEM_2 = 'All the AI generated results',
	RESET_DESCRIPTION = 'Please confirm your decision to reset the platform. This action will permanently delete all user activity and restore the platform to its original settings. Please be aware that this action cannot be undone. To proceed, click on the "Reset Risk Link" button.',
	RESET_BUTTON = 'Reset Risk Link',
	RESET_TEXT = 'reset',
	RESET_PLACEHOLDER = "Type in 'reset'",
}

export enum RESET_TOAST_MESSAGE {
	TOAST_TITLE = 'Platform reset is complete!',
	SUCCESS_MESSAGE = 'All user activities have been deleted, and the platform has been reset to its default state.',
	FAILURE_MESSAGE = 'An error occured while deleting user activities',
}
